/** Shared feed observation adds no duplicate requests. */
export async function fetchJSON(url: string): Promise<any> {
    let data = null;
    try {
        const response = await fetch(url, { cache: "no-cache", signal: AbortSignal.timeout(10_000) });
        if (response.ok) data = await response.json();
    } catch {
        /* Caller handles unavailable data. */
    }
    window.dispatchEvent(new CustomEvent("squaremap:fetch", { detail: { url, ok: data !== null } }));
    return data;
}
